import { render, staticRenderFns } from "./TrialGroup.vue?vue&type=template&id=2943d87a&scoped=true"
import script from "./TrialGroup.vue?vue&type=script&lang=js"
export * from "./TrialGroup.vue?vue&type=script&lang=js"
import style0 from "./TrialGroup.vue?vue&type=style&index=0&id=2943d87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2943d87a",
  null
  
)

export default component.exports